export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.b3b260192bfc412ee09abf340731c849.css";